import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
/**
* @public
*/
const BlockContentIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsxs("svg", {
		"data-sanity-icon": "block-content",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: [
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21 7.60002L11 7.60003V6.40003L21 6.40002V7.60002Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21 11.2667L12.4833 11.2667V10.0667L21 10.0667V11.2667Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21 14.9334H13.9254V13.7334L21 13.7334V14.9334Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21 18.6002H4V17.4002H21V18.6002Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M9.86438 15.6H11.2L8.27623 7.60003H6.92377L4 15.6H5.29072L6.0371 13.4767H9.12362L9.86438 15.6ZM7.53546 9.05255H7.63086L8.80374 12.4344H6.35698L7.53546 9.05255Z",
				fill: "currentColor"
			})
		]
	});
});
export { BlockContentIcon, BlockContentIcon as default };

//# sourceMappingURL=BlockContent.js.map